"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_PAYMENTS_ID = exports.MUTATE_PAYMENT_METHOD_EMAIL = exports.GET_PAYMENT_BY_ID = void 0;
exports.GET_PAYMENT_BY_ID = `
    query getPaymentById($paymentId: String) {
      getPaymentById(paymentId: $paymentId) {
        success
        id
        unappliedAmount
        currency
        type
      }
    }
`;
exports.MUTATE_PAYMENT_METHOD_EMAIL = `
    mutation sendPaymentMethodEmail($paymentMethodEmail: PaymentMethodEmail) {
      sendPaymentMethodEmail(paymentMethodEmail: $paymentMethodEmail){
        success
      }
    }
`;
exports.GET_PAYMENTS_ID = `
  query getPaymentsIdByAccountId($accountId: String) {
    getPaymentsIdByAccountId(accountId: $accountId) 
  }
`;
//# sourceMappingURL=payment-queries.js.map